import { InterviewProgressMixin } from "./90_InterviewProgress.js";

export abstract class ZWaveNodeMixins extends InterviewProgressMixin {}
